import React, { useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { ExportButton } from "@components/Common/Button";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { Awesome, DevModal } from "@components/Helpers";
import { ListingCard } from "@components/Pages";
import { buildGetParamsFromApiData, buildQS, url_reverse } from "@components/Utils";

export default function Royalty() {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:finstatements:royalty"));
    const { api_post, api_get } = useRequest();
    const [showFiscalPreviewModal, setShowFiscalPreviewModal] = useState(false);
    const [currentDeveloper, setCurrentDeveloper] = useState(null);

    if (!apiData) return;

    const year = apiData.forms_data && apiData.forms_data.main.data.year;
    const month = apiData.forms_data && apiData.forms_data.main.data.month;
    const report_type = apiData.forms_data && apiData.forms_data.main.data.report_type;

    const doAction = (ev, ind) => {
        const action = ev.target.name;
        const developer_id = apiData.object_list[ind].developer.id;
        const val = ev.target.type === "checkbox" ? (ev.target.checked ? 1 : 0) : ev.target.value;
        api_post(ev, apiUrl, {
            params: { action, developer_id, report_type, year, month, val },
            then: (resp) => {
                if (resp.status === "ok") {
                    const newApiData = { ...apiData };
                    Object.keys(resp).forEach((k) => {
                        if (k in newApiData.object_list[ind]) {
                            newApiData.object_list[ind][k] = resp[k];
                        }
                    });
                    setApiData(newApiData);
                }
            },
        });
    };

    const handleOpenModal = (obj) => {
        setCurrentDeveloper(obj);
        setShowFiscalPreviewModal(true);
    };

    const handleCloseModal = () => {
        setCurrentDeveloper(null);
        setShowFiscalPreviewModal(false);
    };

    return (
        <ListingCard header={t("Отчет Агента")}>
            <Form>
                <RenderForm colLabel={2} colField={10} submitMethod="get" bareForm={true} />
                <DevForm.Button variant="primary" type="submit" name="action_form" value="main">
                    {t("Найти")}
                </DevForm.Button>
                {report_type === "vkplay_agent_act_phys_smz" &&
                    apiData.object_list &&
                    apiData.object_list.some((obj) => obj.can_make_fiscal) && (
                        <DevForm.Button
                            variant="outline-dark"
                            name="bulk_make_fiscal"
                            className="float-right mr-1"
                            onClick={(ev) => {
                                const getParams = buildGetParamsFromApiData({ apiData, prefix: "main" });
                                getParams.action = ev.target.name;
                                api_get(ev, url_reverse("api:finstatements:royalty") + "?" + buildQS(getParams), {
                                    then: (resp) => {
                                        if (resp.status === "ok") {
                                            alert("Задача поставлена в очередь");
                                        }
                                    },
                                });
                            }}
                        >
                            {t("Отправить все чеки")}
                        </DevForm.Button>
                    )}
                {apiData.object_list && apiData.object_list.some((obj) => obj.can_rep_send) && (
                    <DevForm.Button
                        variant="outline-dark"
                        name="bulk_rep_send"
                        className="float-right mr-1"
                        onClick={(ev) => {
                            const getParams = buildGetParamsFromApiData({ apiData, prefix: "main" });
                            getParams.action = ev.target.name;
                            api_get(ev, url_reverse("api:finstatements:royalty") + "?" + buildQS(getParams), {
                                then: (resp) => {
                                    if (resp.status === "ok") {
                                        alert("Задача поставлена в очередь");
                                    }
                                },
                            });
                        }}
                    >
                        {t("Отправить все отчеты")}
                    </DevForm.Button>
                )}
            </Form>

            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "21%" }}>{t("Компания")}</th>
                        <th style={{ width: "23%" }}>Email</th>
                        <th style={{ width: "7%" }}>{t("Отчёт отправлен")}</th>
                        <th style={{ width: "7%" }}>{t("Чек отправлен")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, ind) => {
                        return (
                            <tr key={`object_list${o.developer.id}`}>
                                <td>
                                    <a href={url_reverse("devs:edit", { dev_id: o.developer.id })}>
                                        {o.developer.company_ru || "---"}
                                    </a>
                                </td>
                                <td>
                                    <ul>
                                        {o.report_emails?.map((email) => {
                                            return <li key={email}>{email}</li>;
                                        })}
                                    </ul>
                                </td>
                                <td>
                                    <DevForm.Checkbox name="is_sent" checked={o.is_sent} disabled={true} />
                                </td>
                                <td>
                                    <DevForm.Checkbox name="is_signed" checked={o.fiscal_check} disabled={true} />
                                </td>
                                <td>
                                    <div>
                                        <ExportButton
                                            className="btn btn-sm btn-success"
                                            apiUrl={url_reverse("api:finstatements:report_cloud:edit", {
                                                report_id: o.cloud_rep_id,
                                            })}
                                            prms={{
                                                report_type: apiData.forms_data.main.data.report_type,
                                                month,
                                                year,
                                                developer_id: apiData.object_list[ind].developer.id,
                                            }}
                                        >
                                            {t("Посмотреть отчет")}
                                        </ExportButton>{" "}
                                        {o.can_to_cloud && (
                                            <>
                                                <DevForm.Button
                                                    variant="primary"
                                                    size="sm"
                                                    name="to_cloud"
                                                    value={ind}
                                                    onClick={(ev) => doAction(ev, ind)}
                                                >
                                                    <Awesome type="cloud-upload" tooltip={t("В облако")} />
                                                </DevForm.Button>{" "}
                                            </>
                                        )}
                                        {o.can_rep_send && (
                                            <>
                                                <DevForm.Button
                                                    variant="primary"
                                                    size="sm"
                                                    name="rep_send"
                                                    value={ind}
                                                    onClick={(ev) => doAction(ev, ind)}
                                                >
                                                    {t("Отправить отчет")}
                                                </DevForm.Button>{" "}
                                            </>
                                        )}
                                        {o.can_make_fiscal && (
                                            <>
                                                <Button variant="info" size="sm" onClick={() => handleOpenModal(o)}>
                                                    {t("Посмотреть чек")}
                                                </Button>{" "}
                                                <DevForm.Button
                                                    variant="warning"
                                                    size="sm"
                                                    name="make_fiscal"
                                                    value={ind}
                                                    onClick={(ev) => doAction(ev, ind)}
                                                >
                                                    {t("Отправить чек")}
                                                </DevForm.Button>{" "}
                                            </>
                                        )}
                                        {o.fiscal_check && (
                                            <>
                                                <a
                                                    className="btn btn-sm btn-warning"
                                                    href={`https://money.mail.ru/fiscal/get/${o.fiscal_check}`}
                                                    target="_blank"
                                                >
                                                    {t("Показать чек")}
                                                </a>{" "}
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                    <FiscalPreviewModal
                        showModal={showFiscalPreviewModal}
                        handleCloseModal={handleCloseModal}
                        currentDeveloper={currentDeveloper}
                    />
                </tbody>
            </Table>
        </ListingCard>
    );
}

export function FiscalPreviewModal({ showModal, handleCloseModal, currentDeveloper }) {
    const { t } = useTranslation();
    const commonInfo = useRouteLoaderData("commonInfo");
    const fiscalData = currentDeveloper?.fiscal_data;
    if (!fiscalData) {
        return null;
    }
    const NDSPrice = (fiscalData.items[0].price * 20) / 120;
    const NDSPriceFloor = Math.round(NDSPrice * 100) / 100;
    return (
        <DevModal
            size="lg"
            show={showModal}
            onHide={handleCloseModal}
            header={t("Предпросмотр чека")}
            body={
                <Container fluid className="receipt-container">
                    <div className="text-center mb-4">
                        <div className="receipt-border">
                            <h4 className="text-uppercase text-muted mb-3">КАССОВЫЙ ЧЕК / ПРИХОД</h4>

                            <h5 className="mb-4">ООО "ВК"</h5>

                            {/* Основная информация - выравнивание по краям */}
                            <div className="mb-3">
                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>{t("ДАТА ВЫДАЧИ")}</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>{commonInfo.now.slice(0, 16)}</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>{t("СМЕНА")}: 00</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>{t("Чек")}№: 000</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>{t("АДРЕС РАСЧЁТОВ")}</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>https://vkplay.ru</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>СНО</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>ОСН</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>{t("ЭЛ.АДРПОКУПАТЕЛЯ")}</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>{fiscalData.user_email}</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>{t("ЭЛ.АДРОТПРАВИТЕЛЯ")}</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>{fiscalData.sender_email}</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>{t("РН ККТ")} 0000000000000000 </div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>{t("ИНН")} 7743001840</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>№{t("ФН")} 0000000000000000 :</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>{t("ФП")} 0000000000</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>№{t("ФД")}:</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>00000</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>№{t("АВТ")}:</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>000000000000</div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>{t("САЙТ ФНС")}:</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>www.nalog.gov.ru</div>
                                    </Col>
                                </Row>
                            </div>

                            <hr className="my-4" />

                            <div className="text-center mb-3">
                                <div className="mb-3">{t("Вознаграждение за размещение Игр на Платформе")}</div>

                                <Row>
                                    <Col xs={6} className="text-left">
                                        <div>1 X {fiscalData.items[0].price}</div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div>= {fiscalData.items[0].price}</div>
                                    </Col>
                                </Row>
                                {fiscalData.items[0].tax_type === "tax_20" && (
                                    <div className="text-right small text-muted mt-2">
                                        {t("в т.ч. НДС 20%")} = {NDSPriceFloor}
                                    </div>
                                )}
                            </div>

                            <Row className="my-3">
                                <Col xs={6} className="text-left">
                                    <small>{t("Признак способа расчета")}</small>
                                </Col>
                                <Col xs={6} className="text-right">
                                    <small>{t("ПЕРЕДАЧА В КРЕДИТ")}</small>
                                </Col>
                            </Row>

                            <hr className="my-4" />

                            <div className="mb-4">
                                <Row className="mb-3">
                                    <Col xs={6} className="text-left">
                                        <h4>{t("ИТОГ")}</h4>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <h4>{fiscalData.items[0].price}</h4>
                                    </Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col xs={8} className="text-left">
                                        <div>{t("ВСЕГО ПОЛУЧЕНО")}:</div>
                                    </Col>
                                    <Col xs={4} className="text-right">
                                        <div>{fiscalData.items[0].price}</div>
                                    </Col>
                                </Row>

                                <Row className="mb-2">
                                    <Col xs={8} className="text-left">
                                        <div>{t("ПОСЛЕДУЮЩАЯ ОПЛАТА (КРЕДИТ)")}:</div>
                                    </Col>
                                    <Col xs={4} className="text-right">
                                        <div>{fiscalData.items[0].price}</div>
                                    </Col>
                                </Row>

                                {fiscalData.items[0].tax_type === "tax_20" ? (
                                    <>
                                        <Row className="mb-2">
                                            <Col xs={8} className="text-left">
                                                <div>{t("НДС 20%")}:</div>
                                            </Col>
                                            <Col xs={4} className="text-right">
                                                <div>{NDSPriceFloor}</div>
                                            </Col>
                                        </Row>
                                    </>
                                ) : (
                                    <Row className="mb-2">
                                        <Col xs={8} className="text-left">
                                            <div>{t("ИТОГО без НДС")}:</div>
                                        </Col>
                                        <Col xs={4} className="text-right">
                                            <div>{fiscalData.items[0].price}</div>
                                        </Col>
                                    </Row>
                                )}
                            </div>
                        </div>
                    </div>
                </Container>
            }
            footer={
                <Button variant="secondary" onClick={handleCloseModal}>
                    {t("Закрыть")}
                </Button>
            }
        />
    );
}
